import { useEffect, useState } from "react";
import AndroidBetaModal from "./AndroidBetaModal";
import { subscribeAndroidBetaOpen } from "../lib/androidBeta";

/**
 * Mounts a single global AndroidBetaModal at the app root and listens for
 * `openAndroidBetaModal()` calls from anywhere in the app.
 */
export default function AndroidBetaMount() {
  const [open, setOpen] = useState(false);
  useEffect(() => subscribeAndroidBetaOpen(() => setOpen(true)), []);
  return <AndroidBetaModal open={open} onClose={() => setOpen(false)} />;
}
